
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Briefcase, Rocket } from 'lucide-react';

const Work = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-black">
        <section className="pt-32 pb-16">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 text-center animate-fade-in-up">
              Το Έργο του Mike
            </h1>
            
            <p className="text-xl text-gray-300 mb-16 text-center max-w-3xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              Ο Mike είναι συνιδρυτής brands που λειτουργούν στην πράξη.
              <br />
              Δεν μένει στη θεωρία. Χτίζει και εξελίσσει κάθε μέρα.
            </p>
            
            {/* RentMySite.gr Section */}
            <div className="grid md:grid-cols-2 gap-12 items-center mb-24 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <div className="flex justify-center md:order-last">
                <div className="w-48 h-48 flex items-center justify-center">
                  <img src="/lovable-uploads/c98b5412-10f8-4e23-8348-b8824e4887d3.png" alt="RentMySite Logo" className="w-full h-full object-contain" />
                </div>
              </div>
              <div className="text-left">
                <h2 className="text-3xl font-bold text-white mb-4">RentMySite.gr – Ιστοσελίδα έτοιμη σε 24 ώρες</h2>
                <p className="text-gray-300 mb-6">
                  Μια καινοτόμα B2B λύση για επαγγελματίες που χρειάζονται γρήγορη, προσιτή και επαγγελματική ιστοσελίδα, χωρίς κόστη κατασκευής. Με έμφαση στην απλότητα και την ταχύτητα, το RentMySite προσφέρει συνδρομητικές ιστοσελίδες που είναι live σε 1 μέρα.
                </p>
                <Button asChild className="bg-brand hover:bg-brand-hover text-white font-medium" size="lg">
                  <a href="https://rentmysite.gr" target="_blank" rel="noopener noreferrer">Μπές στο rentmysite.gr</a>
                </Button>
              </div>
            </div>
            
            {/* Upplead.gr Section */}
            <div className="grid md:grid-cols-2 gap-12 items-center mb-24 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              <div className="flex justify-center">
                <div className="w-48 h-48 flex items-center justify-center">
                  <img src="/lovable-uploads/60ba8848-57d9-4281-80e0-d87eb73a4cde.png" alt="Upplead Logo" className="w-full h-full object-contain" />
                </div>
              </div>
              <div className="text-left">
                <h2 className="text-3xl font-bold text-white mb-4">Upplead.gr – AI & funnels για πραγματικά αποτελέσματα</h2>
                <p className="text-gray-300 mb-6">Κατασκευάζουμε επαγγελματικά eShops & landing pages σε χρόνο ρεκόρ. Εξειδίκευση σε Shopify, διαφημίσεις, και βελτιστοποίηση μετατροπών για επιχειρήσεις που θέλουν να πουλάνε online εύκολα και γρήγορα.</p>
                <Button asChild className="bg-brand hover:bg-brand-hover text-white font-medium" size="lg">
                  <a href="https://upplead.gr" target="_blank" rel="noopener noreferrer">Μπές στο Upplead.gr</a>
                </Button>
              </div>
            </div>
            
            {/* TapG Section */}
            <div className="grid md:grid-cols-2 gap-12 items-center mb-24 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
              <div className="flex justify-center md:order-last">
                <div className="w-48 h-48 flex items-center justify-center">
                  <img src="/lovable-uploads/67599810-d55c-4969-b20c-e4125ec67b96.png" alt="TapG Logo" className="w-full h-full object-contain" />
                </div>
              </div>
              <div className="text-left">
                <h2 className="text-3xl font-bold text-white mb-4">TapG – NFC για επιχειρηματική ανάπτυξη</h2>
                <p className="text-gray-300 mb-6">
                  Η TapG είναι η πρώτη ελληνική πλατφόρμα που ο Mike και η ομάδα του δημιούργησαν, η οποία μετατρέπει ένα απλό tap σε Google αξιολόγηση, social follow ή αγορά. Προϊόντα όπως InfoPlates, NFC κάρτες και αυτοκόλλητα, όλα σχεδιασμένα για φυσικές επιχειρήσεις που θέλουν περισσότερα αποτελέσματα με λιγότερο κόπο.
                </p>
                <Button asChild className="bg-brand hover:bg-brand-hover text-white font-medium" size="lg">
                  <a href="https://tapg.gr" target="_blank" rel="noopener noreferrer">Μπές στο TapG.gr</a>
                </Button>
              </div>
            </div>
            
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Work;
